import React from 'react'

export const CheckboxStepPicture = ({
	img,
	brand,
	settag,
	setwarning,
	setCadenaSeleccionada,
	grocers,
	checked,
	height = null,
	width = null,
}) => {
	const randomId = Math.random()
	return (
		<div className='CheckboxStepPictureWrapper'>
			<input
				type='checkbox'
				id={`checkbox_${randomId}`}
				checked={checked}
				onClick={(e) => {
					settag(true)
					setwarning(null)
					setCadenaSeleccionada(grocers)
				}}
			/>
			<label htmlFor={`checkbox_${randomId}`} className='CheckboxStepPicture'>
				{brand ? (
					<span
						className='brand_label'
						style={checked ? {
							backgroundColor: brand.bg,
							color: '#423f3fff',
						} : {
							backgroundColor: brand.bg + '18',
							color: brand.color,
						}}
					>
						{brand.label}
					</span>
				) : (
					<img src={img} alt=''
					style={{height: height, width: width}}
					/>
				)}
			</label>
		</div>
	)
}
